module.exports = __webpack_public_path__ + "static/img/y13.b16a2e1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/y13.jpg
// module id = cI7X
// module chunks = 1